<template>
    <section v-if="$role.restricAccess($route.name, 'view')">
        <breadcrumb-template :headtitle="$route.meta.title" :breadcrumbcurrent="$route.meta.title"></breadcrumb-template>
        <v-card class="card-outline force-remove-box">
            <v-card-text class="force-custom-bg">
                <v-container fluid>
                    <v-row dense no-gutters class="mb-5 text-center text-md-left subtitle-1">
                        <v-col cols="6" lg="2">
                            Total debit: <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> <strong>{{ dt_total_debit | toNumberWithDecimal }}</strong>
                        </v-col>
                        <v-col cols="6" lg="2">
                            Total credit: <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> <strong>{{ dt_total_credit | toNumberWithDecimal }}</strong>
                        </v-col>
                    </v-row>
                    <v-row dense class="d-flex justify-end mt-n2">
                        
                        <v-col cols="12" md="6" lg="5" xl="2">
                            <!-- <v-text-field clearable hide-details dense outlined v-model="dt_searchInput" @keyup.enter.native="dt_searchQuery = `${dt_searchInput.toString()}`" label="Search"></v-text-field> -->
                            <v-text-field hide-details dense outlined type="date" label="Date to" v-model="filter.date"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6" lg="5" xl="2">
                            <v-text-field clearable dense outlined v-model="dt_searchQuery" label="Search"></v-text-field>
                        </v-col>

                        <v-col cols="12" md="1" :class="($vuetify.breakpoint.mobile) ? 'mb-2':''">
                            <v-btn color="custom_info" class="float-right btn-block" @click="getDataFromApi()"><v-icon>mdi-magnify</v-icon></v-btn>
                        </v-col>

                        <!-- <v-col cols="12" md="3" lg="3" xl="2">
                            <v-btn color="success" class="float-right btn-block" @click="newData()">Add player</v-btn>
                        </v-col> -->

                        <v-col cols="12" class="mt-2">
                            <v-data-table class="custom-header-color table-bordered table-striped" :headers="dt_headers" :items="dt_resultlist" item-key="id" :loading="dt_loading"  :options.sync="dt_options" :server-items-length="dt_totalResult">
                                <template v-slot:[`item.balance`]="{ item }"><v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> {{ (item.balance == null) ? 0.00 : item.balance | toNumberWithDecimal }}</template>
                                <template v-slot:[`item.debit`]="{ item }"><v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> {{ item.debit | toNumberWithDecimal }}</template>
                                <template v-slot:[`item.credit`]="{ item }"><v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> {{ item.credit | toNumberWithDecimal }}</template>
                                <template v-slot:[`item.ending_balance`]="{ item }"><v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin"></v-avatar> {{ (item.ending_balance == null) ? 0.00 : item.ending_balance | toNumberWithDecimal }}</template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>

        <!-- <section>
            <bet-template></bet-template>
        </section> -->

    </section>
</template>

<script>
    export default {
        data(){
            return{
                dialogForm: false,
                isLoadingBtn: false,
                isLoadingBtnDelete: false,
                formerror: {},
                modalUpdate: false,
                dt_headers: [
                    { text: 'Agent/sub-agent', value: 'username', name: 'username', sortable: false, searchable: true},
                    { text: 'Balance forwarded', value: 'balance', name: 'balance', sortable: false, searchable: false},
                    { text: 'Debit', value: 'debit', name: 'debit', sortable: false, searchable: false},
                    { text: 'Credit', value: 'credit', name: 'credit', sortable: false, searchable: false},
                    { text: 'Ending balance', value: 'ending_balance', name: 'ending_balance', sortable: false, searchable: false},
                    // { text: 'Date', value: 'date', name: 'date', sortable: false, searchable: false, width: '10%'},
                ],
                dt_options: {},
                dt_columns:{},
                dt_totalResult: 0,
                dt_searchInput: '',
                dt_searchQuery: "",
                dt_resultlist: [],
                dt_loading: true,
                dt_itemsPerPage: 50,
                dt_reload: '',
                dt_total_debit: 0,
                dt_total_credit: 0,
                form: new this.$Form({
                    id: '',
                    name: '',
                    username: '',
                    email: '',
                    password: '',
                    roles: {},
                    user_status: 1,
                }),
                filter: {
                    date: this.$moment().format("YYYY-MM-DD"),
                    draw: [],
                    daterange: null,
                    status: null
                },
            };
        },
        methods:{
            newData(){
                // this.$Fire.$emit('betdialogbox');
                // this.$router.push({name: 'bet_add'});
            },
            paramsfilter(){
                return {
                    ...this.dt_options,
                    query: this.dt_searchQuery,
                    date: this.filter.date,
                    reload: this.dt_reload,
                };
            },
            async getDataFromApi() {
                this.dt_loading = true;
                var paramsfilter = await this.paramsfilter();
                this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
                let params = await this.$YajraDT.params(paramsfilter, this.dt_options, this.dt_itemsPerPage, this.dt_columns);
                let apiPath = await this.$_CONFIG.api('API_DETAILED_ENTRY');

                await this.$axios.get(apiPath + "?" + this.$.param(params)).then((res) => {
                    if(this.dt_totalResult != res.data.recordsFiltered){ this.dt_options.page = 1; }

                    this.dt_resultlist = res.data.data;
                    this.dt_totalResult = res.data.recordsFiltered;
                    this.dt_total_debit = res.data.debit;
                    this.dt_total_credit = res.data.credit;

                    this.dt_loading = false;
                }).catch((err) => {
                    this.dt_loading = false;
                    console.log("Error searching");
                });

                var unwatch = this.$watch('dt_options.page', function(newValue, oldValue) {
                    this.getDataFromApi();
                    unwatch();
                }, { deep: true });
            },
            // getDataFromApi() {
            //     this.dt_columns = this.$YajraDT.setHeader(this.dt_headers);
            //     this.dt_loading = true;
            //     return new Promise((resolve, reject) => {
                    
            //         let params = this.$YajraDT.params(this.params, this.dt_options, this.dt_itemsPerPage, this.dt_columns);
            //         let apiPath = this.$_CONFIG.api('API_DETAILED_ENTRY');

            //         this.$axios.get(apiPath + "?" + this.$.param(params)).then((res) => {

            //             if(this.$YajraDT.totalPageStore(apiPath + '_otrs', res.data.recordsFiltered)){ this.dt_options.page = 1; }
            //             localStorage.setItem(apiPath + '_otrs', res.data.recordsFiltered);

            //             this.dt_loading = false;

            //             let items = res.data.data;
            //             let total = res.data.recordsFiltered;
            //             let debit = res.data.debit;
            //             let credit = res.data.credit;
                        
            //             resolve({
            //                 items,
            //                 total,
            //                 debit,
            //                 credit
            //             });

            //         }).catch((err) => {
            //             this.dt_loading = false;
            //             console.log("Error searching");
            //         });
            //     });
            // },
        },
        // computed: {
        //     params(nv) {
        //         return {
        //             ...this.dt_options,
        //             query: this.dt_searchQuery,
        //             date: this.filter.date,
        //             reload: this.dt_reload,
        //         };
        //     }
        // },
        // watch: {
        //     params: {
        //         handler() {
        //             this.getDataFromApi().then(data => {
        //                 this.dt_resultlist = data.items;
        //                 this.dt_totalResult = data.total;
        //                 this.dt_total_debit = data.debit;
        //                 this.dt_total_credit = data.credit;
        //             });
        //         },

        //         deep: true
        //     }
        // },
        created(){
            this.getDataFromApi();
        },
        mounted() {
            console.log(this.$moment().format("YYYY-MM-DD"))
        }
    }
</script>
<style scoped>

</style>
